import { useQuery } from '@tanstack/react-query';
import { v2 } from '@/api/client';
import { createQueryClause } from '../query/queryClause';
import { getCacheTime } from '../query/time';

const accountTypes: BusinessEntityCriteria = {
  type: ['region', 'account'],
};

export const useSelectableAccountsQuery = (enabled: boolean) =>
  useQuery({
    queryKey: ['accountSelector'],
    queryFn: () =>
      v2.getPaginated<BusinessEntityBase>(
        'entity',
        { size: 2000, query: createQueryClause(accountTypes) },
        { defaultValue: [] }
      ),
    enabled,
    ...getCacheTime('long'),
  });
